import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-08-20 14:17:52
 * @LastEditTime: 2021-10-13 10:42:58
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React, { useEffect } from 'react';
import { getState, setFormValue } from '@/store/index.js';

const delUndefineValue = obj => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
};

const Holder = props => {
  const {
    Render,
    children
  } = props;
  useEffect(() => {
    var _trailElement$;

    const trailElement = getState('formValues.trailElement');
    let holder = getState('formValues.holder') || {};
    const holderTrail = (trailElement === null || trailElement === void 0 ? void 0 : (_trailElement$ = trailElement[0]) === null || _trailElement$ === void 0 ? void 0 : _trailElement$[0]) || {};
    holder = delUndefineValue(holder);
    setFormValue({
      holder: _objectSpread(_objectSpread({}, holderTrail), holder)
    });
  }, []); // eslint-disable-next-line react/react-in-jsx-scope

  return /*#__PURE__*/React.createElement(Render, {
    components: children
  });
};

export default Holder;